define('app-MultipleItineraries/main',['./settings', 'underscore'], function (settings, _) {
    return {
        run: function () {
            var itineraryPicker = $(settings.itineraryPicker);
            var itineraryModalClose = $(settings.itineraryModalClose);
            var itineraryModalPrint = $(settings.itineraryModalPrint);
            var itineraryModal = $(settings.itineraryModal);
            var viewFullItinerary = $(settings.viewFullItinerary);
            if (itineraryPicker.length === 0) {
                window.log('No ITINERARY PICKER located. app-MultipleItineraries will not be available');
                return;
            }

            var itineraries = [];

            _.each(itineraryPicker.find('option'), function (itinerary) {
                var className = '.' + $(itinerary).val();
                itineraries.push(className);
            });

            // Hide everything except the first one.
            _.each(_.rest(itineraries, 1), function (className) {
                $(className).hide();
            });

            var currentItinerary = _.first(itineraries);
            $(currentItinerary).show();

            // On change, hide everything else and show the correct itinerary.
            itineraryPicker.on("change", function () {
                var chosenItinerary = '.' + itineraryPicker.find(':selected').val();

                $(currentItinerary).slideUp(120, function () {
                    $(chosenItinerary).slideDown(50);

                    currentItinerary = chosenItinerary;
                });
            });

            itineraryModalPrint.on("click", function () {
                var openNewWindow = window.open();
                var divToPrint = $(settings.itineraryContent).html();

                openNewWindow.document.write(divToPrint);
                openNewWindow.window.print();
                openNewWindow.document.close();

                //To close the new blank page that opens.
                setTimeout(function () {
                    openNewWindow.close();
                }, 10);
            });

            viewFullItinerary.on("click", function () {
                $("#header, #slider, .fixedBtn").css("z-index", "-1");
                $("body").append(itineraryModal);
                itineraryModal.modal("show");
                //$(".modal-backdrop").css("z-index", "-1");
            });

            itineraryModal.on("hidden.bs.modal", function () {
                $("#slider").css("z-index", "1");
                $("#header").css("z-index", "11");
                $(".fixedBtn").css("z-index", "999");

                itineraryModal.modal("hide");
            });
        
            window.loadedModules('app-MultipleItineraries');
        }
    }
});
